export default __webpack_public_path__ + "static/media/secure-warning2.ca869181.png";